import PropTypes from "prop-types";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

/** Hộp thoại dạng form: Enter hoặc bấm nút chính sẽ gọi onSubmit. */
function ActionDialog({
  open,
  title,
  onClose,
  onSubmit,
  busy,
  submitText,
  color,
  maxWidth,
  children,
  disabled,
  description,
}) {
  return (
    <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth={maxWidth} fullWidth>
      <MDBox
        component="form"
        onSubmit={(event) => {
          event.preventDefault();
          if (!busy && !disabled) onSubmit();
        }}
      >
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
          <MDBox pt={1} display="flex" flexDirection="column" gap={2}>
            {description && (
              <MDTypography variant="button" color="text">
                {description}
              </MDTypography>
            )}
            {children}
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton variant="text" color="secondary" onClick={onClose} disabled={busy}>
            Huỷ
          </MDButton>
          <MDButton type="submit" variant="gradient" color={color} disabled={busy || disabled}>
            {busy ? "Đang xử lý..." : submitText}
          </MDButton>
        </DialogActions>
      </MDBox>
    </Dialog>
  );
}

ActionDialog.defaultProps = {
  busy: false,
  submitText: "Xác nhận",
  color: "info",
  maxWidth: "sm",
  disabled: false,
  description: null,
};

ActionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  busy: PropTypes.bool,
  submitText: PropTypes.string,
  color: PropTypes.oneOf(["primary", "secondary", "info", "success", "warning", "error", "dark"]),
  maxWidth: PropTypes.oneOf(["xs", "sm", "md", "lg", "xl"]),
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  description: PropTypes.node,
};

export default ActionDialog;
